import axios from "axios";
import config from "../config";
import type { ApiSuccess } from "./api_helper";

const apiBase = config.api.API_URL;

export type WorkspaceSettings = {
  send_approval_required: boolean;
  weekly_digest_enabled: boolean;
  include_web_version_link: boolean;
  preferred_gallery_tag: string | null;
  /** % bounce 7d a partir do qual o Painel alerta (1–20; default 5) — LAC-191. */
  bounce_rate_warn_threshold_percent: number;
  /** Tips / DNS checklist / wizard mode — sync tenant (LAC-111). */
  ui_state?: {
    dismissed_tips?: string[];
    dns_copied?: Record<string, string[]>;
    sending_setup_wizard_mode?: "wizard" | "all";
  };
};

/** Preferências do workspace — rota canônica /me/workspace-settings. */
export const getWorkspaceSettings = async (): Promise<
  ApiSuccess<WorkspaceSettings>
> => {
  return axios.get(apiBase + "/me/workspace-settings");
};

export const updateWorkspaceSettings = async (
  payload: Partial<WorkspaceSettings>
): Promise<ApiSuccess<WorkspaceSettings>> => {
  return axios.patch(apiBase + "/me/workspace-settings", payload);
};
